import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  CompanyGlobalFinancialMonitoringPartOneFormType,
  FormErrors,
  getSchema,
} from '../../forms/companyGlobalFinancialMonitoringPartOneForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: CompanyGlobalFinancialMonitoringPartOneFormType;
  onSubmit: (values: CompanyGlobalFinancialMonitoringPartOneFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
}

export const CompanyGlobalFinancialMonitoringPartOne = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t);

  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={t('onboarding.companyGlobalFinancialMonitoring.subtitle')}
      title={t('onboarding.companyGlobalFinancialMonitoring.partOne.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormContainer>
  );
};
